module.exports = __webpack_public_path__ + "static/media/HelveticaNeueLTPro85Heavy.397becf1.otf";